<template>
    <div class="footer">
        <div class="mainwidth">
            <ul class="footcon">
                <li class="alizi-copyright">
                    <div class="copyright">Copyright © 2009-2025 NTFusion 广州岸腾信息科技有限公司 粤ICP备15003881号 All Rights Reserved</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                contents: ''
            }
        },
    }
</script>
<style lang="less">
    .mainwidth {
        margin: 0 auto;
        width: 1000px;
        text-align: center;
    }
    .footer .mainwidth{background:url('../../static/default/img/line_1.png') repeat-x left 0;padding:40px 0}
    .footcon li{display:inline-block;color:#685852;padding:0 29px 0 28px;}
    .footcon li:first-child{padding-left:0;background:none}
    .footcon li.li_4{padding-right:0}
    .footcon .copyright{line-height:1.8}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue